import { useTranslation } from 'react-i18next'
import type { ScoreRangeCalculationTypeModel } from '@/api/model'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/shadcn/card'
import { ScoreRanges } from '@/pages/action-modules/components/ScoreRanges'
import { useActionModuleDetail } from '../ActionModuleDetailPage'
import { isManualBulkUploadModule, isScoreRangeModule } from '../lib'
import { ExcelImportCard } from './ExcelImportCard'

/**
 * Import / Export tab. The Excel-upload area is functional (Manual + bulk-upload modules
 * only); for ScoreRange modules the score-range table sits to its right.
 */
export default function ImportExportTab() {
  const { t } = useTranslation('action-modules-detail')
  const { module } = useActionModuleDetail()

  const canBulkUpload = isManualBulkUploadModule(module)
  const scoreRanges = isScoreRangeModule(module)
    ? (module.rewardCalculationType as ScoreRangeCalculationTypeModel).scoreRanges ?? []
    : null

  return (
    // p-1 so the cards' ring/shadow isn't clipped by the overflow-auto edge.
    <div className="mt-4 flex min-h-0 flex-1 flex-col gap-8 overflow-auto p-1">
      {canBulkUpload ? (
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start">
          <div className="flex min-w-0 flex-1 flex-col">
            <ExcelImportCard module={module} />
          </div>
          {scoreRanges && (
            <Card className="flex min-w-0 flex-1 flex-col">
              <CardHeader>
                <CardTitle className="text-base">{t('importExport.scoreRanges.title')}</CardTitle>
              </CardHeader>
              <CardContent>
                <ScoreRanges scoreRanges={scoreRanges} bare />
              </CardContent>
            </Card>
          )}
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">{t('importExport.excelUpload.notAvailable')}</p>
      )}
    </div>
  )
}
